import { useState } from "react";

import { C, FEEDBACK, IG_HANDLE, SHIPPING_ZONES, WOMPI_API_PROXY, fmtMoney, genId } from "../data/handcraftsConfig";
function ProductCard({ p, addedId, onDetail, onBuy, soldIds }) {
  const isSold = soldIds && soldIds.includes(p.id);
  return (
    <div className="product-card" style={{position:"relative",opacity:isSold ? 0.65 : 1}}>
      {isSold && <span style={{position:"absolute",top:13,left:13,zIndex:2,background:FEEDBACK.error,color:C.background,fontSize:"var(--text-label)",padding:"4px 10px",borderRadius:2,letterSpacing:"1px",textTransform:"uppercase"}}>Agotado</span>}
      {addedId===p.id && <span className="added-flash">✓ Agregado</span>}
      <div className="product-media" style={{cursor:"pointer",opacity:isSold?0.55:1}} onClick={()=>onDetail(p)}>
        <img src={p.img} alt={p.name} />
      </div>
      <div style={{padding:"14px 16px 16px",display:"flex",alignItems:"center",gap:8}}>
        <span className="sans" style={{fontSize:"var(--text-body)",color:isSold?C.inkMuted:C.ink,flex:1}}>${p.price}</span>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-outline" style={{fontSize:"var(--text-label)",padding:"8px 13px"}} onClick={()=>onDetail(p)}>Ver</button>
          {isSold
            ? <button className="btn" disabled style={{fontSize:"var(--text-label)",padding:"8px 13px",background:C.rule,color:C.ink,borderRadius:2,border:"none",cursor:"not-allowed"}}>Agotado</button>
            : <button className="btn btn-solid" style={{fontSize:"var(--text-label)",padding:"8px 13px"}} onClick={()=>onBuy(p)}>Comprar</button>
          }
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  CHECKOUT MODAL  (cart → confirm → wompi redirect)
// ─────────────────────────────────────────────────────────────────────────────
function CheckoutModal({ cart, onClose, onSuccess }) {

  const [step, setStep]       = useState("summary"); // "summary" | "loading" | "done" | "error"
  const [orderId]             = useState(() => genId());
  const [errMsg, setErrMsg]   = useState("");
  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    phone: "",
    instagram: "",
    address: "",
    city: "",
    country: "El Salvador",
    notes: "",
    shippingZone: "sv_metro"
  });

  const subtotal  = cart.reduce((s, p) => s + p.price * p.qty, 0);
  const igDMUrl   = `https://www.instagram.com/${IG_HANDLE}/`;
  const returnUrl = `${window.location.origin}${window.location.pathname}?page=pago-resultado&orderId=${encodeURIComponent(orderId)}`;

  // ── Call PHP proxy → Wompi SV API → get urlEnlace ────────────────────────
  // Wompi El Salvador uses OAuth2 + REST (not a public-key widget).
  // Credentials stay server-side in api/wompi.php.
  const handleWompi = async () => {
    if (!customer.name.trim() || !customer.phone.trim() || !customer.city.trim()) {
      setErrMsg("Faltan tu nombre, teléfono o ciudad. Completálos para seguir al pago.");
      setStep("error");
      return;
    }

    setStep("loading");
    setErrMsg("");
    try {
      const productNames = cart.map(p => `${p.name} x${p.qty}`).join(", ");
      const wompiPayload = {
        identificadorEnlaceComercio: orderId,
        monto: subtotal,
        nombreProducto: productNames.slice(0, 490),
        descripcionProducto: `Pedido Handcrafts By Abu: ${productNames}`.slice(0, 1000),
        detalleProductos: cart.map((p) => ({
          id: p.id,
          nombre: p.name,
          cantidad: p.qty,
          precioUnitario: p.price,
          subtotal: Number((p.price * p.qty).toFixed(2))
        })),
        redirectUrl: returnUrl,
        urlRedirect: returnUrl,
        metadata: {
          source: "handcraftsbyabu-web",
          orderId,
          customerName: customer.name,
          customerPhone: customer.phone,
          customerCity: customer.city
        }
      };
      const res = await fetch(WOMPI_API_PROXY, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(wompiPayload)
      });
      const data = await res.json();
      if (!res.ok || !data.urlEnlace) {
        throw new Error(data.error || "Wompi no devolvió el enlace de pago. Intentá otra vez en unos minutos.");
      }
      onSuccess(orderId, "Wompi", customer);
      window.location.assign(data.urlEnlace);
      setStep("done");
    } catch (e) {
      setErrMsg(e.message || "No se pudo conectar con Wompi. Revisá tu conexión e intentá otra vez.");
      setStep("error");
    }
  };

  return (
    <div className="overlay" onClick={step==="done" ? undefined : onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}
        style={{maxWidth:500, padding:0, overflow:"hidden", display:"flex", flexDirection:"column", maxHeight:"92vh"}}>

        {/* ── HEADER ── */}
        <div className="on-ink" style={{background:C.ink,padding:"20px 24px",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
            <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
              <span className="logo-on-ink" style={{width:32,height:32,flexShrink:0}} role="img" aria-label="Handcrafts By Abu"/>
              <div>
              <div style={{fontSize:"var(--text-body)",color:C.background,lineHeight:1.2}}>
                {step==="summary" ? "Tu pedido" : step==="loading" ? "Creando el pago" : step==="error" ? "Error" : "Pedido confirmado"}
              </div>
              {step !== "done" && step !== "loading" && (
                <div style={{fontSize:"var(--text-label)",marginTop:3}}>
                  Pedido #{orderId}
                </div>
              )}
              </div>
            </div>
            {step !== "done" && step !== "loading" && (
              <button onClick={onClose}
                style={{background:C.inkStrong,border:"none",borderRadius:2,width:30,height:30,
                  cursor:"pointer",color:C.background,fontSize:"var(--text-body)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                ✕
              </button>
            )}
          </div>
        </div>

        {/* ── BODY ── */}
        <div style={{overflowY:"auto",flex:1,padding:"22px 24px"}}>

          {/* STEP 1 — ORDER SUMMARY + WOMPI */}
          {step==="summary" && (
            <div>
              {/* Items */}
              <div style={{background:C.surface,borderRadius:2,padding:"16px 18px",border:`1.5px solid ${C.rule}`,marginBottom:16}}>
                <div style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:12}}>
                  Resumen del pedido
                </div>
                {cart.map((p,i) => (
                  <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <img src={p.img} alt={p.name} style={{width:40,height:40,objectFit:"cover",borderRadius:2,border:`1px solid ${C.rule}`,flexShrink:0}}/>
                      <div>
                        <div style={{fontSize:"var(--text-body)",color:C.ink}}>{p.name}</div>
                        <div style={{fontSize:"var(--text-label)",color:C.ink}}>× {p.qty}</div>
                      </div>
                    </div>
                    <div style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(p.price*p.qty)}</div>
                  </div>
                ))}
                <div style={{borderTop:`1.5px solid ${C.rule}`,marginTop:12,paddingTop:12,display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:"var(--text-body)",color:C.ink}}>Total</span>
                  <span style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(subtotal)}</span>
                </div>
              </div>

              <div style={{background:C.surface,borderRadius:2,border:`1.5px solid ${C.rule}`,padding:"18px",marginBottom:16}}>
                <div style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:14}}>
                 Datos para entrega y contacto
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12}}>
                  {[
                    { key:"name", label:"Nombre completo", type:"text", required:true },
                    { key:"phone", label:"Teléfono", type:"text", required:true },
                    { key:"email", label:"Email", type:"email" },
                    { key:"instagram", label:"Instagram", type:"text" },
                    { key:"city", label:"Ciudad / municipio", type:"text", required:true },
                    { key:"country", label:"País", type:"text" },
                  ].map((field) => (
                    <label key={field.key} className="sans" style={{fontSize:"var(--text-label)",color:C.ink,display:"flex",flexDirection:"column",gap:6}}>
                      {field.label}{field.required ? " *" : ""}
                      <input
                        type={field.type}
                        value={customer[field.key]}
                        onChange={(e) => setCustomer((prev) => ({ ...prev, [field.key]: e.target.value }))}
                        style={{padding:"11px 12px",borderRadius:2,border:`1.5px solid ${C.rule}`,fontSize:"var(--text-body)"}}
                      />
                    </label>
                  ))}
                  <label className="sans" style={{fontSize:"var(--text-label)",color:C.ink,display:"flex",flexDirection:"column",gap:6}}>
                   Zona de envio
                    <select
                      value={customer.shippingZone}
                      onChange={(e) => setCustomer((prev) => ({ ...prev, shippingZone: e.target.value }))}
                      style={{padding:"11px 12px",borderRadius:2,border:`1.5px solid ${C.rule}`,fontSize:"var(--text-body)",background:C.surface}}
                    >
                      {SHIPPING_ZONES.map((zone) => (
                        <option key={zone.id} value={zone.id}>{zone.label}</option>
                      ))}
                    </select>
                  </label>
                </div>
                <label className="sans" style={{fontSize:"var(--text-label)",color:C.ink,display:"flex",flexDirection:"column",gap:6,marginTop:12}}>
                 Direccion de entrega
                  <textarea
                    value={customer.address}
                    onChange={(e) => setCustomer((prev) => ({ ...prev, address: e.target.value }))}
                    rows={3}
                    style={{padding:"11px 12px",borderRadius:2,border:`1.5px solid ${C.rule}`,fontSize:"var(--text-body)",resize:"vertical"}}
                  />
                </label>
                <label className="sans" style={{fontSize:"var(--text-label)",color:C.ink,display:"flex",flexDirection:"column",gap:6,marginTop:12}}>
                 Notas del pedido
                  <textarea
                    value={customer.notes}
                    onChange={(e) => setCustomer((prev) => ({ ...prev, notes: e.target.value }))}
                    rows={2}
                    style={{padding:"11px 12px",borderRadius:2,border:`1.5px solid ${C.rule}`,fontSize:"var(--text-body)",resize:"vertical"}}
                  />
                </label>
              </div>

              {/* Shipping note */}
              <div style={{background:C.surface,borderRadius:2,padding:"12px 16px",border:`1px solid ${C.rule}`,display:"flex",gap:10,alignItems:"flex-start",marginBottom:20}}>
                <p style={{fontSize:"var(--text-body)",color:FEEDBACK.warning,lineHeight:1.65,margin:0}}>
                 El envío en El Salvador se calcula por zona. Para Estados Unidos, Abu confirma el costo final con vos.
                </p>
              </div>
              <div style={{background:C.surface,borderRadius:2,padding:"12px 16px",border:`1px solid ${C.rule}`,display:"flex",gap:10,alignItems:"flex-start",marginBottom:20}}>
                <p style={{fontSize:"var(--text-body)",color:FEEDBACK.info,lineHeight:1.65,margin:0}}>
                 Tu pieza se marca como vendida solo cuando Wompi confirma el pago.
                </p>
              </div>

              {/* Wompi pay button */}
              <div style={{background:C.surface,borderRadius:2,border:`2px solid ${C.rule}`,padding:"20px",textAlign:"center"}}>
                {/* Wompi logo */}
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:"var(--text-body)",color:C.inkStrong,lineHeight:1}}>Wompi</div>
                  <div className="label" style={{marginTop:6}}>Pago seguro</div>
                </div>
                <p style={{fontSize:"var(--text-body)",color:C.ink,lineHeight:1.7,marginBottom:16}}>
                  Acepta <strong>tarjeta de crédito/débito</strong>, Puntos Agrícola, Bitcoin (Chivo Wallet) y más.<br/>
                 Serás redirigido a la plataforma segura de Wompi El Salvador.
                </p>
                {/* Payment icons row */}
                <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:18,flexWrap:"wrap"}}>
                  {["Visa","Mastercard","Puntos Agrícola","Bitcoin","Chivo Wallet"].map(label => (
                    <span key={label} style={{fontSize:"var(--text-label)",
                      padding:"4px 9px",borderRadius:2,background:C.surface,color:C.ink,border:`1px solid ${C.rule}`}}>
                      {label}
                    </span>
                  ))}
                </div>
                <button onClick={handleWompi}
                  style={{width:"100%",padding:"15px 0",borderRadius:2,border:"none",
                    background:C.inkStrong,color:C.background,fontSize:"var(--text-body)",cursor:"pointer",
                    transition:"opacity .2s"}}
                  onMouseEnter={e=>e.currentTarget.style.opacity=".9"}
                  onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                  Pagar {fmtMoney(subtotal)} con Wompi →
                </button>
                <p style={{fontSize:"var(--text-label)",color:C.ink,marginTop:10}}>
                  Transacción cifrada · Certificado PCI DSS
                </p>
              </div>
            </div>
          )}

          {/* LOADING */}
          {step==="loading" && (
            <div style={{textAlign:"center",padding:"40px 0"}}>
              <div className="spinner"/>
              <p style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:8}}>
               Conectando con Wompi...
              </p>
              <p style={{fontSize:"var(--text-body)",color:C.ink}}>
               Generando tu enlace de pago seguro.
              </p>
            </div>
          )}

          {/* ERROR */}
          {step==="error" && (
            <div style={{textAlign:"center",padding:"32px 0"}}>
              <h3 style={{fontSize:"var(--text-body)",marginBottom:8,color:C.ink}}>No se pudo crear el pago</h3>
              <div style={{background:C.surface,borderRadius:2,padding:"12px 16px",border:`1px solid ${C.rule}`,marginBottom:20}}>
                <p style={{fontSize:"var(--text-body)",color:FEEDBACK.error,margin:0}}>{errMsg}</p>
              </div>
              <p style={{fontSize:"var(--text-body)",color:C.ink,lineHeight:1.7,marginBottom:16}}>
               Intentá otra vez, o escribile a Abu por Instagram.
              </p>
              <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer"
                style={{display:"inline-flex",alignItems:"center",gap:8,
                  background:C.ink,color:C.background,
                  padding:"12px 24px",borderRadius:2,
                  fontSize:"var(--text-body)",textDecoration:"none"}}>
                 Ir a @{IG_HANDLE}
</a>
            </div>
          )}

          {/* STEP 2 — DONE */}
          {step==="done" && (
            <div style={{textAlign:"center",padding:"8px 0"}}>
              <h3 style={{fontSize:"var(--text-body)",marginBottom:8,color:C.ink}}>Pedido registrado</h3>
              <p style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:14,lineHeight:1.7}}>
               Completaste el pago con Wompi. Guardá tu número de pedido. Abu revisa tus datos de entrega y te escribe si falta algo.
              </p>

              {/* Order ID card */}
              <div className="on-ink" style={{background:C.ink,borderRadius:2,padding:"18px 24px",marginBottom:20,width:"100%",boxSizing:"border-box"}}>
                <div style={{fontSize:"var(--text-label)",marginBottom:6,textTransform:"uppercase",letterSpacing:"2px"}}>Tu número de pedido</div>
                <div style={{fontSize:"var(--text-body)",color:C.background,letterSpacing:3}}>{orderId}</div>
                <div style={{fontSize:"var(--text-label)",marginTop:6}}>{fmtMoney(subtotal)} · {cart.map(p=>p.name).join(", ")}</div>
              </div>

              {/* IG redirect */}
              <div style={{background:C.surface,borderRadius:2,padding:"18px",border:`1.5px solid ${C.rule}`,marginBottom:16,textAlign:"left"}}>
                <p style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:8}}>
                 Resumen para tu seguimiento
                </p>
                <p style={{fontSize:"var(--text-body)",color:C.ink,lineHeight:1.75,marginBottom:16}}>
                 Puedes guardar estos datos y escribirle a Abu solo si quieres agregar una aclaración adicional.
                </p>
                <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:18}}>
                  {[`Número de pedido: ${orderId}`,"Dirección registrada en tu pedido","Comprobante de pago Wompi"].map((item,i) => (
                    <div key={i} style={{display:"flex",alignItems:"center",gap:8,background:C.surface,borderRadius:2,padding:"9px 12px",border:`1px solid ${C.rule}`}}>
                      <span style={{fontSize:"var(--text-body)",color:C.ink}}>{item}</span>
                    </div>
                  ))}
                </div>
                <a href={igDMUrl} target="_blank" rel="noreferrer"
                  style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                    background:C.ink,color:C.background,
                    padding:"14px 0",borderRadius:2,
                    fontSize:"var(--text-body)",textDecoration:"none"}}>
                  Ir a @{IG_HANDLE} →
                </a>
              </div>
              <p style={{fontSize:"var(--text-label)",color:C.ink}}>Abu te responde por Instagram.</p>
            </div>
          )}
        </div>

        {/* ── FOOTER ── */}
        <div style={{padding:"14px 24px",borderTop:`1.5px solid ${C.rule}`,background:C.surface,flexShrink:0,display:"flex",gap:10}}>
          {step==="summary" && (
            <button onClick={onClose}
              style={{padding:"11px 18px",borderRadius:2,border:`2px solid ${C.rule}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>
              ← Carrito
            </button>
          )}
          {step==="error" && (
            <>
              <button onClick={()=>setStep("summary")}
                style={{padding:"11px 18px",borderRadius:2,border:`2px solid ${C.rule}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>
                ← Atrás
              </button>
              <button onClick={handleWompi}
                style={{flex:1,padding:"13px 0",borderRadius:2,border:"none",
                  background:C.inkStrong,color:C.background,fontSize:"var(--text-body)",cursor:"pointer"}}>
               Reintentar →
              </button>
            </>
          )}
          {step==="done" && (
            <button onClick={onClose}
              style={{flex:1,padding:"12px 0",borderRadius:2,border:`2px solid ${C.rule}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>
             Cerrar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  ADMIN COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

export { ProductCard, CheckoutModal };
